// Formatiert eine Datum im Format TT.MM.JJJJ

export const formatDate = (input: string | Date = new Date(), defaultValue = '00.00.0000'): string => {
	let dateObj: Date;

	if (typeof input === 'string') {
		dateObj = new Date(input);
	} else {
		dateObj = input;
	}

	if (!input || isNaN(dateObj.getTime())) {
		return defaultValue;
	}

	const year = dateObj.getFullYear();
	const month = String(dateObj.getMonth() + 1).padStart(2, '0');
	const day = String(dateObj.getDate()).padStart(2, '0');

	return `${day}.${month}.${year}`;
};
